import { ScrollReveal } from '@/components/shared/ScrollReveal'
import { teaching } from '@/content/portfolio'
import { BadgeCheck, BookOpen, ExternalLink, GraduationCap } from 'lucide-react'

const items = [
  { ...teaching.program, label: 'Teaching & judging', Icon: GraduationCap },
  { ...teaching.participation, label: 'Participation reference', Icon: BadgeCheck },
  { ...teaching.publication, label: 'Publication', Icon: BookOpen },
]

export function Community() {
  return (
    <section id="teaching" className="scroll-mt-24 border-t border-vibe-border bg-vibe-black py-16 lg:py-24">
      <div className="mx-auto max-w-6xl px-4 lg:px-8">
        <ScrollReveal>
          <div className="section-label mb-2">Community, teaching &amp; publications</div>
          <h2 className="text-3xl lg:text-4xl font-medium tracking-tight text-text-heading">
            Sharing practical product, AI, and emerging-tech work
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.04}>
          <article className="mt-10 overflow-hidden rounded-2xl border border-vibe-border bg-card-bg lg:grid lg:grid-cols-[0.85fr_1.15fr]">
            <div className="flex flex-col justify-center p-5 lg:p-8">
              <div className="section-label text-accent-primary">Community activity</div>
              <h3 className="mt-3 text-2xl font-medium tracking-tight text-text-heading">
                {teaching.chainlink.title}
              </h3>
              <p className="mt-4 text-[15px] leading-relaxed text-text-secondary">
                {teaching.chainlink.description}
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {['Blockchain research', 'Knowledge sharing', 'Workshop hosting'].map((item) => (
                  <span
                    key={item}
                    className="rounded-sm border border-vibe-border-strong px-2 py-1 font-mono text-[10px] uppercase tracking-widest text-text-primary/80"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-px bg-vibe-border" aria-label="Chainlink community event photos">
              {teaching.chainlink.images.map((image, index) => (
                <figure key={image.src} className={index === 0 ? 'col-span-2 aspect-[16/9]' : 'aspect-[4/3]'}>
                  <img
                    src={image.src}
                    alt={image.alt}
                    loading="lazy"
                    className="h-full w-full object-cover"
                  />
                </figure>
              ))}
            </div>
          </article>
        </ScrollReveal>

        <div className="mt-5 grid gap-4 lg:grid-cols-3">
          {items.map(({ Icon, ...item }, index) => (
            <ScrollReveal key={item.title} delay={index * 0.05}>
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex h-full items-start gap-4 rounded-lg border border-vibe-border bg-card-bg p-5 transition-colors hover:border-accent-primary/50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-accent-primary lg:p-8"
              >
                <Icon className="mt-0.5 h-6 w-6 shrink-0 text-accent-primary" aria-hidden="true" />
                <div className="flex-1">
                  <div className="section-label mb-2">{item.label}</div>
                  <h3 className="text-lg font-medium tracking-tight text-text-heading">{item.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-text-secondary">{item.description}</p>
                  <div className="mt-4 inline-flex items-center gap-1.5 font-mono text-xs uppercase tracking-widest text-accent-primary">
                    Open reference <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
                  </div>
                </div>
              </a>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  )
}
